import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { AppForm, DynamicFormContainer } from "../../../../components";
import { FormContextProvider, TabPanelContext } from "../../../../context/ContextIndex";
import { getReplacementDeviceSchema, getReplacementDeviceDefaultValue } from "../../replacement-device/create/schema";

const ReplacementDeviceCreate = ({ onSubmit, onCancel }) => {
  const { t } = useTranslation();
  const _tabContextObject = useContext(TabPanelContext);
  const _tabContext = _tabContextObject.getTabFormContext();

  const selectedDevice = _tabContext.data?.selectedReplacementDevice;
  const existingRanges = _tabContext?.data?.replacementDevice ? _tabContext?.data?.replacementDevice : [];

  const _formattedRange = existingRanges
    .filter((item) => !selectedDevice || item.id !== selectedDevice.id)
    .map((item) => ({
      startRange: parseFloat(item.StartFrequencyReposition),
      endRange: parseFloat(item.EndFrequencyReposition),
    }));


  const defaultFormValues = selectedDevice
    ? selectedDevice // If editing, use selected device
    : getReplacementDeviceDefaultValue();

  const [formdata] = useState({
    replacementDeviceSchema: getReplacementDeviceSchema(_formattedRange),
    appformdata: null,
  });

  const onReplacementDeviceSubmit = (data) => {
    const newDevice = {
      ...data,
      id: selectedDevice ? selectedDevice.id : _tabContext.data?.replacementDevice?.length || 0,
      ReplaceDeviceId: selectedDevice ? selectedDevice.ReplaceDeviceId : null
    };

    _tabContextObject.setTabFormContext({
      data: {
        ..._tabContext.data,
        replacementDevice: _tabContext.data?.replacementDevice
          ? (
            _tabContext.data.replacementDevice.some(device => device.id === newDevice.id)
              ? _tabContext.data.replacementDevice.map(device =>
                device.id === newDevice.id
                  ? newDevice  // If device with the same ID exists, replace it
                  : device     // Otherwise, keep the original device
              )
              : [..._tabContext.data.replacementDevice, newDevice]  // If no device with the same ID exists, add new one
          )
          : [newDevice],  // If there are no existing device, create an array with the new one
        selectedReplacementDevice: null
      },
      isDirty: true
    });


    onSubmit(); // Close form after submit
  };

  return (
    <FormContextProvider
      schema={formdata.replacementDeviceSchema}
      defaultValues={defaultFormValues}
      appformdata={formdata.appformdata}
    >
      <AppForm onSubmit={onReplacementDeviceSubmit}>
        <DynamicFormContainer
          header={t("createDevice.replacement%Device")}
          onCancel={onCancel}
          onSaveLabel={t("generic.save")}
        />
      </AppForm>
    </FormContextProvider>
  );
};

export default ReplacementDeviceCreate;
